export type SourceType = "sharepoint" | "local";

export interface ProcessingOptions {
  longEdgePx: number; // 2500
  jpegQuality: number; // 80 (entspricht Bridge Q8)
  dpi: number; // 150
  // Obergrenze für die reinen JPEG-Bilddaten (ohne EXIF). Wird pro Bild gesetzt,
  // weil der EXIF-Anteil je nach Kamera unterschiedlich groß ist.
  maxBytes?: number;
}

export const DEFAULT_OPTIONS: ProcessingOptions = {
  longEdgePx: 2500,
  jpegQuality: 80,
  dpi: 150,
};

// Jede Ausgabedatei (inkl. EXIF) bleibt unter 1 MB. Reicht Q80 nicht, wird die
// Qualität nur so weit gesenkt wie nötig, aber nie unter MIN_JPEG_QUALITY.
export const MAX_FILE_BYTES = 1_000_000;
export const MIN_JPEG_QUALITY = 65;

// Zuschnitt-Rechteck, NORMALISIERT (0..1) relativ zur Bildgröße. Unabhängig von
// der Vorschau-Auflösung; der Worker rechnet beim Zuschneiden auf Pixel um.
export interface CropRect {
  x: number;
  y: number;
  w: number;
  h: number;
}

export interface ProcessResult {
  outputName: string;
  bytes: Uint8Array;
  originalWidth: number;
  originalHeight: number;
  outputWidth: number;
  outputHeight: number;
  wasResized: boolean;
  jpegQuality: number; // tatsächlich verwendete Qualität (80, oder weniger bei > 1 MB)
}

export interface ProcessingError {
  fileName: string;
  message: string;
}
